<script lang="ts">
export default {
  name: "BaseDropdownItem",
  inheritAttrs: false,
};
</script>
<script lang="ts" setup>
import {
  BaseButtonKindEnum,
  BaseButtonSizeEnum,
} from "@/components/Base/Button";
import { type BootstrapIconName } from "@/types/bootstrap-icons";
import { type Props as BaseIconProps } from "@/components/Base/Icon/index.vue";

export type Props = {
  disabled?: boolean;
  to?: RouterLinks;
  href?: string;
  iconName?: BootstrapIconName;
  iconColor?: BaseIconProps["color"];
  iconBgColor?: string;
  label?: string;
  value?: string | number;
};

defineProps<Props>();
</script>

<template>
  <li :class="{ disabled }" class="base-dropdown-item">
    <IconButton
      class="dropdown-item base-dropdown-item__button"
      type="button"
      :kind="BaseButtonKindEnum.LINK"
      variant="dark"
      icon-position="left"
      :label="label"
      :value="value"
      :icon-name="iconName"
      :icon-color="iconColor"
      :icon-bg-color="iconBgColor"
      :disabled="disabled"
      :to="to"
      :href="href"
      :inline="true"
      :size="BaseButtonSizeEnum.SM"
      v-bind="$attrs"
    >
      <slot></slot>
    </IconButton>
  </li>
</template>
<style scoped lang="scss">
.base-dropdown-item {
  list-style: none;

  &__button {
    width: 100%;
    justify-content: start;
    display: flex;
    align-items: center;
    gap: $spacer-2;

    --bs-dropdown-link-hover-bg: var(--hover-color);
    --bs-dropdown-link-active-bg: var(--hover-color-dark);
    --bs-dropdown-link-active-color: var(--color-black);

    // due to conflicting styles in btn and dropdown-item we need to nudge the icon down a bit
    :deep(.bi) {
      transform: translateY(0.07em);
    }

    &.text-danger:active {
      background-color: $color-red;
      color: $white !important;
    }

    &__description {
      font-size: 0.9rem;
      font-weight: 400;
      white-space: normal;
      color: $color-gray-500;
    }

    &--lg {
      display: flex;
      align-items: flex-start;
      gap: $spacer-2;
    }

    &--selected {
      position: relative;

      &::before {
        content: "";
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        width: 2px;
        background-color: $primary;
      }
    }
  }
}

.disabled {
  cursor: not-allowed;
}
</style>
